import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=2ae233a8&scoped=true&"
import script from "./receipt.vue?vue&type=script&lang=js&"
export * from "./receipt.vue?vue&type=script&lang=js&"
import style0 from "./receipt.vue?vue&type=style&index=0&id=2ae233a8&scoped=true&lang=css&"
import style1 from "./receipt.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae233a8",
  null
  
)

export default component.exports